import {api} from "./api.service";

export class GratitudeService {
    static async getGratitude(
        order = "desc",
        sort = "createdAt",
    ) {
        const params = {};

        if (sort) {
            params["sort"] = "createdAt";
        }
        if (order) {
            params["order"] = "desc";
        }

        return api.get(`gratitude`, { params });

    }
    static async createGratitude(data) {
        return  api.post(`gratitude`, data);
    }
    static async deleteGratitude(id) {
        return  api.delete(`gratitude/${id}`);
    }
    static async getSingleGratitude(id) {
        return  api.get(`gratitude/${id}`);
    }
    static async editGratitude(id, data) {
        return  api.patch(`gratitude/${id}`,data);
    }
}
